import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserState } from "../definitions";

const initialState: UserState = {
  id: "",
  name: "",
  preferred_username: "",
  email: "",
  roles: [],
  orgId: "",
  auth: {
    accessToken: "",
    account: null,
    idToken: "",
    expiresOn: new Date(),
  },
};

const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    setAuthData: (state, action: PayloadAction<UserState>) => {
      return {
        ...state,
        id: action.payload.id,
        name: action.payload.name,
        preferred_username: action.payload.preferred_username,
        email: action.payload.email,
        roles: action.payload.roles,
        orgId: action.payload.orgId,
        auth: {
          accessToken: action.payload.auth.accessToken,
          account: action.payload.auth.account,
          expiresOn: action.payload.auth.expiresOn,
          idToken: action.payload.auth.idToken,
        },
      };
    },
    updateOrgId: (state, action: PayloadAction<string>) => {
      state.orgId = action.payload;
    },
    deleteAuthData: (state) => {
      return initialState;
    },
  },
});

export default authSlice.reducer;
export const { setAuthData, updateOrgId, deleteAuthData } = authSlice.actions;
